/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Clientbanner_Subheading1Inputs */

const id_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bantu petakan setiap build Epic Games Store`)
};

const ms_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bantu petakan setiap binaan Epic Games Store`)
};

const da_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hjælp med at kortlægge alle Epic Games Store builds`)
};

const de_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Helfen Sie mit, jeden Epic Games Store Build zu kartieren`)
};

const en_us2_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help map every Epic Games Store build`)
};

const es_es2_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ayuda a mapear cada compilación de la Epic Games Store`)
};

const es_mx2_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ayuda a mapear cada compilación de la Epic Games Store`)
};

const fil_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tumulong i-map ang bawat Epic Games Store build`)
};

const fr_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aidez à cartographier chaque compilation de l'Epic Games Store`)
};

const it_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aiuta a mappare ogni build dell'Epic Games Store`)
};

const hu_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segíts feltérképezni minden Epic Games Store buildet`)
};

const nl_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help elke Epic Games Store-build in kaart te brengen`)
};

const no_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hjelp med å kartlegge hver Epic Games Store-build`)
};

const pl_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomóż zmapować każdą kompilację Epic Games Store`)
};

const pt_br2_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help map every Epic Games Store build`)
};

const pt_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajude a mapear cada compilação da Epic Games Store`)
};

const ro_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajută la maparea fiecărei compilări Epic Games Store`)
};

const fi_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auta kartoittamaan jokainen Epic Games Store -koontiversio`)
};

const sv_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hjälp till att kartlägga varje Epic Games Store-bygge`)
};

const vi_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giúp lập bản đồ mọi bản dựng Epic Games Store`)
};

const tr_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her Epic Games Store yapısını haritalamaya yardımcı olun`)
};

const cs_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomozte zmapovat každé sestavení Epic Games Store`)
};

const bg_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Помогнете за картографирането на всяка компилация на Epic Games Store`)
};

const ru_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Помогите составить карту каждой сборки Epic Games Store`)
};

const uk_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Допоможіть зібрати всі збірки Epic Games Store`)
};

const ar_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ساعد في رسم خريطة كل بنية Epic Games Store`)
};

const hi_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हर बिल्ड को मैप करने में मदद करें`)
};

const th_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ช่วยจัดทำแผนที่ทุกบิลด์ของ Epic Games Store`)
};

const ja_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての Epic Games Store ビルドのマッピングに協力`)
};

const zh_cn2_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help map every Epic Games Store build`)
};

const zh_hant1_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help map every Epic Games Store build`)
};

const ko_components_clientbanner_subheading1 = /** @type {(inputs: Components_Clientbanner_Subheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help map every Epic Games Store build`)
};

/**
* | output |
* | --- |
* | "Help map every Epic Games Store build" |
*
* @param {Components_Clientbanner_Subheading1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_clientbanner_subheading1 = /** @type {((inputs?: Components_Clientbanner_Subheading1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Clientbanner_Subheading1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_clientbanner_subheading1(inputs)
	if (locale === "ms") return ms_components_clientbanner_subheading1(inputs)
	if (locale === "da") return da_components_clientbanner_subheading1(inputs)
	if (locale === "de") return de_components_clientbanner_subheading1(inputs)
	if (locale === "en-US") return en_us2_components_clientbanner_subheading1(inputs)
	if (locale === "es-ES") return es_es2_components_clientbanner_subheading1(inputs)
	if (locale === "es-MX") return es_mx2_components_clientbanner_subheading1(inputs)
	if (locale === "fil") return fil_components_clientbanner_subheading1(inputs)
	if (locale === "fr") return fr_components_clientbanner_subheading1(inputs)
	if (locale === "it") return it_components_clientbanner_subheading1(inputs)
	if (locale === "hu") return hu_components_clientbanner_subheading1(inputs)
	if (locale === "nl") return nl_components_clientbanner_subheading1(inputs)
	if (locale === "no") return no_components_clientbanner_subheading1(inputs)
	if (locale === "pl") return pl_components_clientbanner_subheading1(inputs)
	if (locale === "pt-BR") return pt_br2_components_clientbanner_subheading1(inputs)
	if (locale === "pt") return pt_components_clientbanner_subheading1(inputs)
	if (locale === "ro") return ro_components_clientbanner_subheading1(inputs)
	if (locale === "fi") return fi_components_clientbanner_subheading1(inputs)
	if (locale === "sv") return sv_components_clientbanner_subheading1(inputs)
	if (locale === "vi") return vi_components_clientbanner_subheading1(inputs)
	if (locale === "tr") return tr_components_clientbanner_subheading1(inputs)
	if (locale === "cs") return cs_components_clientbanner_subheading1(inputs)
	if (locale === "bg") return bg_components_clientbanner_subheading1(inputs)
	if (locale === "ru") return ru_components_clientbanner_subheading1(inputs)
	if (locale === "uk") return uk_components_clientbanner_subheading1(inputs)
	if (locale === "ar") return ar_components_clientbanner_subheading1(inputs)
	if (locale === "hi") return hi_components_clientbanner_subheading1(inputs)
	if (locale === "th") return th_components_clientbanner_subheading1(inputs)
	if (locale === "ja") return ja_components_clientbanner_subheading1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_clientbanner_subheading1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_clientbanner_subheading1(inputs)
	return ko_components_clientbanner_subheading1(inputs)
});
export { components_clientbanner_subheading1 as "components.clientBanner.subheading" }